import React, { useMemo } from 'react';

import { MenuConfig, MenuTemplate, PlaceHolderImageGenerationEnum } from 'src/apollo/sites';
import { formatImageURL } from 'src/lib/js/utilities';

import Image from 'shared/components/common/Image';

import { DefaultPlaceHolderMenuImage } from 'public/components/default_template/menu_section/DefaultPlaceHolderMenuImage';
import { MenuItem } from 'public/components/default_template/menu_section/MenuSection';
import { TemplateOverrides } from 'public/components/default_template/menu_section/menuStylingOverrides';

export const CLICKED_MENU_ITEM_EVENT_NAME = 'Clicked menu item';
export const CLICKED_MENU_ITEM_EVENT_NO_NAME_STR = 'No name';

export const IMAGE_SUFFIX_REGEX = /\.(jpg|png)$/;

export type ToastImageSet = {
  xs?: string;
  small?: string;
  medium?: string;
  large?: string;
}

type MenuItemImageSet = {
  '140w'?: string
  '300w'?: string
  '600w'?: string
  '900w'?: string
}

// These source set URLs are served by the toast photo service
// and are guaranteed to exist
export const getMenuItemSrcSet = (images: ToastImageSet): MenuItemImageSet => {
  const imgSet: MenuItemImageSet = {};
  if(images.xs) { imgSet['140w'] = formatImageURL(images.xs); }
  if(images.small) { imgSet['300w'] = formatImageURL(images.small); }
  if(images.medium) { imgSet['600w'] = formatImageURL(images.medium); }
  if(images.large) { imgSet['900w'] = formatImageURL(images.large); }
  return imgSet;
};

export const getTemplateClass = (template: MenuTemplate | undefined | null): string => {
  if(!template) return '';
  const classStr = template ? template.toString() : '';
  if(!classStr) return '';
  return classStr.charAt(0).toLowerCase() + classStr.slice(1);
};


type ItemContentProps = {
  item: MenuItem;
  menuGuid?: string | null;
  // If true, formats the layout of the card as a popular item card.
  isPopularItem?: boolean;
  menuConfig?: MenuConfig | null;
  rowHasDescription?: boolean;
  templateOverrides?: TemplateOverrides;
  isReadOnly?: boolean;
}

export const MenuItemImage = (props: ItemContentProps) => {
  const { item, templateOverrides } = props;

  const itemImage = useMemo(() => {
    let imgSrc = item.imageUrls?.medium || item.imageUrls?.small || item.imageUrls?.large || item.imageUrls?.xs;
    imgSrc = imgSrc && formatImageURL(imgSrc);
    const imgSrcSet = item.imageUrls && getMenuItemSrcSet(item.imageUrls);

    if(item?.image) {
      return <Image alt="" src={item.image} className="itemImage" data-testid={item.name + '-image'} />;
    } if(imgSrc && imgSrcSet) {
      return <Image src={imgSrc} srcSet={imgSrcSet} className="itemImage" alt="" />;
    } else if(templateOverrides?.placeholderImageConfig.generatePlaceholderImage === PlaceHolderImageGenerationEnum.RepeatedText) {
      return <DefaultPlaceHolderMenuImage className="itemImage" templateOverrides={templateOverrides} />;
    } else {
      return null;
    }
  }, [item, templateOverrides]);

  return itemImage;
};
